import React, { useState, useEffect } from 'react';
import "../Layout/manage.css";
import "../Layout/layout.css";
import ProductManage from './productManage';

function Manage() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const isScreen = windowWidth > 768;
  const content = isScreen ? <Desktop /> : <Mobile />;

  return (
    <body>
      {content}
    </body>
  );
};

const Desktop = () => {
  return (
    <body class='Desktop' style={{display:"flex"}}>
      <div className='list-manage'>

      </div>
      <div className='Content-manage'>
      <ProductManage />
      </div>
    </body>
  );
};
const Mobile = () => {
  return (
    <body>
       
    </body>
  );
};
export default Manage;
